import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import './ContactView.css';
import { ButtonSubmit } from '../ButtonSquare';
import TitleHeader from '../TitleHeader';
import logoComdeslezards from './assets/img/logo_comdeslezards.png';

function handleSubmit() {
  window.ga('send', 'event', {
    eventCategory: 'Mail',
    eventAction: 'sent',
  });
}

function handlePhoneClick() {
  window.ga('send', 'event', {
    eventCategory: 'Phone',
    eventAction: 'clicked',
  });
}

class ContactView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCaptcha: false,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange() {
    this.setState({
      showCaptcha: true,
    });
  }

  render() {
    return (
      <div className="contact-view-body" id="contact">
        <img
          className="contact_view_logo"
          src={logoComdeslezards}
          alt="logo comdeslézards com des lézards"
        />
        <div className="contact-view-container">
          <TitleHeader
            title="Pour plus d'informations"
            titleColor="#2f1275"
            subtitle="Contactez nous !"
            subtitleColor="white"
          />
          <div className="contact-view-infos">
            <div className="contact-view-address">
              <p>
            54, avenue des îles d'or
                <br />
            83400, Hyères
                <br />
                <br />
                <a
                  href="tel:0766890921"
                  className="contact-view-phone"
                  onClick={handlePhoneClick}
                >
              07 66 89 09 21
                </a>
              </p>
            </div>
            <form
              method="post"
              className="contact-form"
              action="https://comdeslezards-n8n-10adc5fb1055.herokuapp.com/webhook/99a56e66-bce6-4a78-8aff-a1e2f7b26d04"
              name="contactForm"
              onSubmit={handleSubmit}
            >
              <input name="email" type="email" placeholder="VOTRE EMAIL" onChange={this.handleChange} />
              <textarea
                name="message"
                placeholder="VOTRE MESSAGE"
                cols="30"
                rows="10"
                required
                style={{ marginBottom: '1rem' }}
              />
              { this.state.showCaptcha && <ReCAPTCHA sitekey="6LcuQX4UAAAAALuSJ_kg8EoFmDK_nD3M1j-32jtL" /> }
              <ButtonSubmit />
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default ContactView;



// WEBPACK FOOTER //
// ./src/components/ContactView/ContactView.jsx